import { Base64 } from 'js-base64'
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function getTimeStamp() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}
// export function createUniqueString() {
//   const timestamp = +new Date() + ''
//   const randomNum = parseInt((1 + Math.random()) * 65536) + ''
//   return (+(randomNum + timestamp)).toString(32)
// }

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function getIeVersion() {
  var ieEditionName = navigator.appName
  var ieVersion = navigator.appVersion.split(';')
  var ieTrimVersion = ieVersion[1].replace(/[/]/g, '').substring(6, 7)
  // 获取是否为ie10.0
  var ie10 = ieVersion[1].replace(/[/]/g, '').split(' ')[2]
  var IE = 11
  if (ieEditionName === 'Microsoft Internet Explorer' && ieTrimVersion === 6) {
    IE = 6
  } else if (ieEditionName === 'Microsoft Internet Explorer' && ieTrimVersion === 7) {
    IE = 7
  } else if (ieEditionName === 'Microsoft Internet Explorer' && ieTrimVersion === 8) {
    IE = 8
  } else if (ieEditionName === 'Microsoft Internet Explorer' && ieTrimVersion === 9) {
    IE = 9
  } else if (ieEditionName === 'Microsoft Internet Explorer' && ie10 === '10.0') {
    IE = 10
  }
  return IE
}

export function getServerDate(){
  var time,date;
  var xhr = null;
  if(window.XMLHttpRequest){
    xhr = new window.XMLHttpRequest();
  }else{ // ie
    xhr = new ActiveObject("Microsoft")
  }
  xhr.open("GET","/",true);
  xhr.send(null);
  xhr.onreadystatechange=function(){
    if(xhr.readyState == 2){
      time = xhr.getResponseHeader("Date");
      date = new Date(time).getTime();
      // console.log(date);
    }
  }
  return date
}

export function isEmptyOrNull(val) {
  if (val === undefined || val === '' || val === null) {
    return true
  } else {
    return false
  }
}

export function showMsg(type, content, width, height, time ) {
	layer.open({
		type: type,
		title:false,
		closeBtn:false,
		content:content,
		area:[width, height],
		time:time
	});
}

// export function getTimeStamp() {
//   let str = ''
//   for (let i = 0; i < 15; i++) {
//     str += Math.floor(Math.random() * 10)
//   }
//   return str
// }

// 校验登录名，只能是英文字母，或者英文字母数字组合.
export function checkLoginName(str) {
  const reg = /^[A-Za-z0-9]+$/
  return reg.test(str)
}

export function checkPasswordValidate(password) {
  return /^(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{6,20}$/.test(password)
}

export function checkMobilePhone(str) {
	if (str.match("^1([0-9][0-9])\\d{8}$") == null) {
		return false
	} else {
		return true
	}
}

export function setLvAddr(addr) {
  let url = Base64.encode(addr)
  let day1 = setCookiesExpire(1)
  document.cookie = "_lv=" + url +";domain=.gpyh.com;path=/;expires="  + day1.toGMTString()
}

export function setCookiesExpire(days) {
  var exp = new Date()
  exp.setTime(exp.getTime() + days*24*60*60*1000)
  return exp
}

export function clearNoInt(value) {
  if (!isEmptyOrNull(value)) {
    value = value + ''
    return value.replace(/[^\d]/g,"");  //清除“数字”和“.”以外的字符
  }
  return value
}

//允许输入小数位的数字
export function clearNoFloat(value){
  if (!isEmptyOrNull(value)) {
    value = value + ''
    let temp = value.replace(/[^\d.]/g,"");//清除“数字”和“.”以外的字符  
    temp = temp.replace(/^\./g,"");//验证第一个字符是数字而不是. 
    temp = temp.replace(/\.{2,}/g,".");//只保留第一个. 清除多余的. 
    temp = temp.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
    return temp
  }
  return value
}
// 获取特定结构的数据字段"[{"key":"XXXX","value":"XXXX"}]"
export function getKeyValueToArr(temp) {
  if (isEmptyOrNull(temp)) {
    return []
  } else {
    const arr = []
    let temp1 = temp.slice(1,temp.length-1).split(',{')

    temp1.forEach(item => {
      arr.push({
        key: item.split('"value":"')[0].split('"key":"')[1].split('",')[0],
        value: item.split('"value":"')[1].split('"}')[0]
      })
    })   
    return arr
  }
}

//获取url具体字段
export function getQueryString(name) { 
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = '' 
  if (isEmptyOrNull(window.location.search)) {
    r = window.location.href.split('?')[1].match(reg);
  } else {
    r = window.location.search.substr(1).match(reg); 
  }
  if (r != null) return decodeURIComponent(r[2]); return null; 
}

export function getQueryString1(name) { 
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = '' 
  if (isEmptyOrNull(window.location.search)) {
    if(window.location.href.split('?')[1]){
      r = window.location.href.split('?')[1].match(reg);
    }
  } else {
    if(window.location.search.substr(1)){
      r = window.location.search.substr(1).match(reg);
    }
  }
  if (r != null) return decodeURIComponent(r[2]); return null; 
}

export function replaceURLParamVal(oUrl, paramName,replaceWith) {
  // var oUrl = window.location.href.toString();
  var re = eval('/('+ paramName+'=)([^&]*)/gi');
  var nUrl = oUrl.replace(re,paramName+'='+replaceWith);
  return nUrl
}

/* 银行账号*/
export function checkBankAccount(str) {
  const reg = /^([0-9]|[-]){6,25}$/
  return reg.test(str)
}

export function setCookiesExpireHour(hour) {
  var exp = new Date()
  exp.setTime(exp.getTime() + hour*60*60*1000)
  return exp
}


// WEBPACK FOOTER //
// ./src/utils/index.js